/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const ModelSection = Loadable(lazy(() => import("sections/models/development/index")));
const SchemaList = Loadable(lazy(() => import("sections/models/development/schema-list/schema-list")));
const SchemaDetail = Loadable(lazy(() => import("sections/models/development/schema-list/schema-detail")));

const modelRoutes = [
    {
        path: "development",
        element: <ModelSection />,
    },
    {
        path: "/development/schema",
        element: <SchemaList />,
    },
    {
        path: "/development/schema/:type",
        element: <SchemaDetail />,
    }
];
export { modelRoutes };
